import { useMemo } from "react";
import { useTranslation } from "@coworker/locales";
import { TodaysProgress } from "./TodaysProgress";
import { Rounds } from "../Rounds/Rounds";
import FullScreenPopup from "@coworker/apprestructured/src/layout/components/FullScreenPopup/FullScreenPopup";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import { FilterPanel } from "@coworker/apprestructured/src/shared/filters/components/FilterPanel";
import { useShoppingToolsFilters } from "../Hooks/useShoppingToolsFilters";

export const ProgressOverview = () => {
  const { t } = useTranslation();
  const shoppingToolsFilters = useShoppingToolsFilters({
    showRound: true,
    showPeriod: false,
  });

  const linkbarItems = useMemo(() => {
    return [
      {
        label: t("shoppingToolsHeaderString"),
        to: "/shoppingtools",
      },
    ];
  }, [t]);

  return (
    <FullScreenPopup
      noPadding
      linkbar={
        <Linkbar
          items={linkbarItems}
          currentLabel={t("shoppingToolsProgress")}
          currentAsH1
        />
      }
    >
      <FilterPanel
        filterValues={shoppingToolsFilters.filterValues}
        setFilterValues={shoppingToolsFilters.setFilterValues}
        useFiltersFactory={shoppingToolsFilters.useFiltersFactory}
        feature="shopping-tools-progress"
      />
      <TodaysProgress
        shoppingToolsFilters={shoppingToolsFilters.filterValues}
      />
      <Rounds shoppingToolsFilters={shoppingToolsFilters.filterValues} />
    </FullScreenPopup>
  );
};
